// extracted by mini-css-extract-plugin
module.exports =  {"button":"_2d525abc69--button--wvpRY"};